import { RefObject } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import SVGImage from '~/components/Image/SVGImage'
import useAvatarImageUrl from '~/dashboard/hooks/useAvatarImageUrl'

export default function LearningPathAvatarIcon({
  avatarRef,
  className = '-mt-12',
}: {
  avatarRef: RefObject<HTMLDivElement>
  className?: string
}): React.ReactElement {
  const avatarImageObject = useAvatarImageUrl()

  return (
    <div
      className={`absolute bg-gradient-to-b from-blue-logo via-pink-logo to-orange h-16 w-16 p-1 rounded-full ${className} ml-16 z-20`}
      ref={avatarRef}
    >
      <div className="flex justify-center items-center bg-white h-full w-full rounded-full overflow-hidden">
        <div className="scale-150 pt-4">
          {!avatarImageObject.isExists || avatarImageObject.isUnder13 ? (
            <SVGImage imageClassName="scale-150" srcKey={avatarImageObject.url} />
          ) : (
            <ResponsiveImage
              height={80}
              imageClassName="scale-200 pl-0.5 pt-5"
              src={avatarImageObject.url}
              width={80}
            />
          )}
        </div>
      </div>
    </div>
  )
}
